export const FETCH_USER_DETAILS = 'fetchUserDetails';
export const CHANGE_USER = 'changeUser';
export const LOGIN_USER = 'login';
export const LOGOUT_USER = 'logout';
export const IMPERSONATE_USER = 'impersonateUser';

export const CUSTOMERS_FETCH = 'customersFetch';
export const CUSTOMERS_NEW = 'customersNew';
export const CUSTOMERS_EDIT = 'customersEdit';
export const CUSTOMERS_ACTIVE = 'customersActive';
export const CUSTOMER_TRANSLATE_TABLE = 'customerTranslateTable';

export const PARTNERS_FETCH = 'partnersFetch';
export const PARTNERS_CREATE = 'partnersCreate';
export const PARTNERS_EDIT = 'partnersEdit';
export const PARTNERS_REMOVE = 'partnersRemove';
export const PARTNERS_FILTERS = 'partnersFilters';
export const PARTNERS_REDIRECT = 'partnersRedirect';

export const TRANSLATIONS_FETCH = 'translationsFetch';

export const NUTRIENTS_FETCH = 'nutrientsFetch';

export const SYSCONFIG_FETCH = 'sysConfigFetch';
export const SYSCONFIG_UPDATE_SOURCE = 'sysConfigUpdateSource';
